import Button from '@/components/Button';
import { useNotes } from '../../hooks/useNotes';
import { useMissionDetailingStore } from '@/pages/mission/detailing/store/useMissionDetailingStore';

export const ChapterNotes = () => {
  const { value, onChangeValue, onChangeNotes, createNotesLoading, updateNotesLoading } = useNotes();
  const missionPage = useMissionDetailingStore((state) => state.missionPage);

  return (
    <div className="mb-6">
      <div className="mt-5">
        <h3 className="mb-2 font-cadiz text-lg font-bold ">{missionPage?.notesArea?.label}</h3>
        <textarea
          className="w-full rounded-md border border-gray-300 p-3 focus:border-primary-500 focus:outline-none"
          rows={4}
          value={value}
          onChange={(e) => onChangeValue(e.target.value)}
          placeholder={missionPage?.notesArea?.placeholder}
        />
        <Button
          theme="solid-primary-600"
          onClick={() => onChangeNotes(value)}
          className="mt-3"
          disabled={createNotesLoading || updateNotesLoading}
          loading={createNotesLoading || updateNotesLoading}>
          {missionPage?.notesArea?.buttonText}
        </Button>
      </div>
    </div>
  );
};
